import type { QueryClient } from 'react-query'

export const notificationQueryKeys = {
  list: (userId: number) => ['notifications', userId] as const,
  unreadCount: (userId: number) => ['notifications', 'unread-count', userId] as const,
}

/** Refetch notification badge/list after actions that create notifications on the server. */
export function invalidateNotifications(queryClient: QueryClient, userId?: number) {
  if (userId) {
    void queryClient.invalidateQueries(notificationQueryKeys.list(userId))
    void queryClient.invalidateQueries(notificationQueryKeys.unreadCount(userId))
    return
  }
  void queryClient.invalidateQueries(['notifications'])
}
